import { GridColDef } from "@mui/x-data-grid";
import { formatDateAndTime } from "../../../../helpers/appHelpers";

export const AuditLogColumns: GridColDef[] = [
    {
        field: "timestamp",
        headerName: "Timestamp",
        minWidth: 220,
        flex: 1,
        headerClassName: "super-app-theme--header",
        sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
        valueGetter: (params) => formatDateAndTime(params),
    },
    {
        field: "user",
        headerName: "User",
        minWidth: 220,
        flex: 1,
        headerClassName: "super-app-theme--header",
        valueGetter: (params) => params.value?.name || "User",
    },
    {
        field: "action",
        headerName: "Action",
        minWidth: 250,
        flex: 1,
        headerClassName: "super-app-theme--header",
    },
    // {
    // 	field: "input",
    // 	headerName: "Input",
    // 	minWidth: 220,
    //  flex: 1,
    // 	headerClassName: "super-app-theme--header",
    // 	valueGetter: (params) => params.value || "--",
    // },
    {
        field: "modifiedAt",
        headerName: "Modified At",
        minWidth: 220,
        flex: 1,
        headerClassName: "super-app-theme--header",
        sortComparator: (date1, date2) => new Date(date1).getTime() - new Date(date2).getTime(),
        valueGetter: (params) => params.value ? formatDateAndTime(params) : "--",
    },
];